export var OBJECT_ID = '_objectId'; // Symbol('object_id');
export var objectReferencePrefix = 'OID:';
//# sourceMappingURL=constants.js.map